var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { "justify-center": "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "500px" },
              model: {
                value: _vm.dialog,
                callback: function ($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "text-h5" }, [_vm._v("Share")]),
                  ]),
                  _c(
                    "v-flex",
                    { attrs: { xs6: "", "offset-xs3": "" } },
                    [
                      _c(
                        "v-card-text",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.emailSend,
                              expression: "emailSend",
                            },
                          ],
                          staticClass: "emailSend",
                        },
                        [_vm._v("Email sent")]
                      ),
                      _c(
                        "v-card-text",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errorEmail,
                              expression: "errorEmail",
                            },
                          ],
                          staticClass: "errorEmail",
                        },
                        [_vm._v("Error email")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        { attrs: { "grid-list-md": "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "*Mittente - Sender email",
                                      hint: "example@example.com",
                                    },
                                    model: {
                                      value: _vm.emailFrom,
                                      callback: function ($$v) {
                                        _vm.emailFrom = $$v
                                      },
                                      expression: "emailFrom",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "*Destinatario - Recipient email",
                                      hint: "example@example.com",
                                    },
                                    model: {
                                      value: _vm.emailTo,
                                      callback: function ($$v) {
                                        _vm.emailTo = $$v
                                      },
                                      expression: "emailTo",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-textarea", {
                                    attrs: { label: "Note" },
                                    model: {
                                      value: _vm.notes,
                                      callback: function ($$v) {
                                        _vm.notes = $$v
                                      },
                                      expression: "notes",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("small", [_vm._v("*indicates required field")]),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "green darken-1", text: "" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.closeDialog.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("Close")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "green darken-1", text: "" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.condividi()
                            },
                          },
                        },
                        [_vm._v("Invia")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-tooltip",
        {
          key: "5",
          staticClass: "text-center",
          attrs: { top: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "ma-0 pa-0 btnCanvas",
                          staticStyle: {
                            background: "transparent !important",
                            "pointer-events": "all",
                          },
                          attrs: {
                            rounded: "",
                            regular: "",
                            elevation: "0",
                            disabled: !_vm.configurationComplete,
                          },
                          on: { click: _vm.openShareDialog },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c(
                        "v-icon",
                        { attrs: { large: "", dark: "", color: "primary" } },
                        [_vm._v("share")]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_vm._v(" Share ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }